export default __webpack_public_path__ + "static/media/Lasting Faith Belt.df89e476.jpg";